import { render, staticRenderFns } from "./imgV.vue?vue&type=template&id=d2124692"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2124692')) {
      api.createRecord('d2124692', component.options)
    } else {
      api.reload('d2124692', component.options)
    }
    module.hot.accept("./imgV.vue?vue&type=template&id=d2124692", function () {
      api.rerender('d2124692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholders/imgV.vue"
export default component.exports